import { defineNuxtPlugin, addRouteMiddleware } from '#app'

/**
 * Plugin to apply auth middleware to all routes
 */
export default defineNuxtPlugin(() => {
  // Apply auth middleware globally
  addRouteMiddleware('global-auth', async (to) => {
    // This will apply the auth middleware defined in middleware/auth.ts
    // The middleware itself handles checking for public routes and authentication status
  }, { global: true })
})
